import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
} from "@chakra-ui/react";
import NeedForm from "./NeedForm";
import { useTranslation } from "react-i18next";
import {
  MODAL_CONTENT_SX,
  MODAL_HEADER_SX,
} from "../../../components/Portal/portalModalChrome";

const NeedFormModal = ({ isOpen, onClose, initialData, onSuccess }) => {
  const { t } = useTranslation("portal");
  const isEdit = Boolean(initialData?.id);
  const stopScrollEventPropagation = (e) => {
    e.stopPropagation();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="5xl"
      scrollBehavior="inside"
      blockScrollOnMount={false}
      portalProps={{ appendToParentPortal: false }}
    >
      <ModalOverlay bg="rgba(11,31,58,.45)" />
      <ModalContent
        sx={MODAL_CONTENT_SX}
        maxH="calc(100vh - 4rem)"
        display="flex"
        flexDirection="column"
        onWheelCapture={stopScrollEventPropagation}
        onTouchMoveCapture={stopScrollEventPropagation}
      >
        <ModalHeader sx={MODAL_HEADER_SX}>
          {isEdit
            ? t("pilotNeeds.form.modalTitleEdit")
            : t("pilotNeeds.form.modalTitleCreate")}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody
          pb={6}
          flex="1"
          minH={0}
          overflowY="auto"
          overscrollBehavior="contain"
          onWheelCapture={stopScrollEventPropagation}
          onTouchMoveCapture={stopScrollEventPropagation}
        >
          <NeedForm
            initialData={initialData}
            onSuccess={onSuccess}
            onCancel={onClose}
            isEdit={isEdit}
            isActive={isOpen}
            showBackButton={false}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default NeedFormModal;
